
import Vue, { PropType } from 'vue'
import { BulkGatewaysTransactionRow } from '@/models'

import GatewayBulkUploadListHeader from '@/views/company/gateways/components/GatewayBulkUploadListHeader.vue'
import GatewayBulkUploadListItem from '@/views/company/gateways/components/GatewayBulkUploadListItem.vue'

export default Vue.extend({
  name: 'GatewayBulkUploadList',

  props: {
    rows: Array as PropType<Array<BulkGatewaysTransactionRow>>,
  },

  components: {
    GatewayBulkUploadListHeader,
    GatewayBulkUploadListItem,
  },
})
